export const helpMenuTxt = {
  CONSOLE_DOCUMENTATION: "Console documentation",
  API_DOCUMENTATION: "API documentation",
  TRUST_AND_SECURITY: "Trust and security",
  LIVE_AND_ON_DEMAND: "Live & on-demand",
};
